module.exports = __webpack_public_path__ + "static/media/2.a72214c0.png";